import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

import { SessionStorageService } from 'src/app/services/session-storage.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { UserNavigationService } from 'src/app/services/user-navigation.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { WindowEventsService } from 'src/app/services/window-events.service';
import { IframeService } from 'src/app/services/iframe.service';
import { BaseWebsiteComponent } from '../base-website/base-website.component';
import { PendoService } from 'src/app/services/pendo.service';
import { pairwise, startWith } from 'rxjs/operators';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
    standalone: true,
    selector: 'app-validation-client-portal',
    templateUrl: './validation-client-portal.component.html',
    styleUrls: ['./validation-client-portal.component.scss']
})

export class ValidationClientPortalComponent
    extends BaseWebsiteComponent
    implements OnInit, OnDestroy {

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public logger: LoggingMessageService,
        public sessionService: SessionStorageService,
        public navigationService: UserNavigationService,
        public authService: AuthService,
        public windowEvents: WindowEventsService,
        public pendoService: PendoService,
        public iframeService: IframeService,
        public sanitizer: DomSanitizer,
        public subscriptionService: SubscriptionChangeService) {

        super(router, route, logger, sessionService, navigationService, authService, windowEvents, iframeService, pendoService, sanitizer, subscriptionService);
    }

    ngOnInit() {
        this.reqestSizeFromIFrame();
        super.ngOnInit();
        this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription;
        this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    }

    subscribeToChildSiteEvents() {
        this.subscribeIndicatorResizingEvents();
        this.subscribePortalLogin();
        this.subscribePortalLogout();
        this.subscribeSubDomainActionEvents();
        this.subscribePortalActionEvents();

        const vLoadedSubscription = this.iframeService.validationFrameLoaded$
            .subscribe(v => this.reqestSizeFromIFrame());
        this.$subscriptions.add(vLoadedSubscription);

        this.subscribeToPreviousValue();
    }

    getIframeReferences() {
        if (!this.visibleIframe) {
            this.visibleIframe = document.getElementById('appValidationIFrame') as HTMLIFrameElement;
        }
    }

    loadIframe(path: string) {
        const loggedIn = this.authService.isUserLoggedIn();
        if ((loggedIn === true) && (path !== '/login')) {
            const displayedMenu = this.navigationService.DisplayedNavigationMenu;
            if (displayedMenu && displayedMenu.Items && displayedMenu.Items.length > 0) {
                this.setIframeSource(path);
                this.checkAccessToken(path);
                this.iframeService.setValidationFrameVisibility(true);
                this.iframeService.setLinkId('');
            }
        } else {
            this.setIframeSourceWithLogin(path);
        }
    }

    setIframeSource(path: string) {
        const iframe = this.visibleIframe;
        if (iframe) {
            path = path.replace('/if/validation', '/upload'); // /updaload can be removed if path from menu items is updated to include them
            const user = this.authService.getUser();
            this.logger.debug('validation-client-portal', 'setIframeSource', this.selectedSubscriptionID , this.availableSubscriptions , `Src: ${path}`, '');
            this.currentUrl = path;
            // this.visibleSrc = this.sanitizer.bypassSecurityTrustResourceUrl(path);
            this.iframeService.setValidationFrameSource(path);
            this.navigationService.emitNavigationComplete(this.linkid);
        }
    }

    updateIframeHeight(data: any) {
        const iframe = this.visibleIframe;
        if (iframe) {
            const height = parseFloat(data);
            if (height > 1000) {
                iframe.style.height = (height + 100) + 'px';
                const user = this.authService.getUser();
                this.logger.debug('validation-client-portal', 'handleHeightChangeEent', this.selectedSubscriptionID , this.availableSubscriptions ,`Setting IFrame height to ${data}`, '');
            } else {
                iframe.style.height = '1000px'; // Minimum height is set as 1000px
            }
        }
    }

    private subscribeIndicatorResizingEvents() {
        const indicatorSubscription = this.windowEvents.indicatorResizing$
            .subscribe(size => {
                this.updateIframeHeight(size);
            });
        this.$subscriptions.add(indicatorSubscription);
    }

    private subscribeToPreviousValue() {
        const prevSubscription = this.iframeService.validationSource$.pipe(
            startWith(this.currentUrl),
            pairwise())
            .subscribe(([previousValue, currentValue]) => {
                this.previousUrl = previousValue;
            });
        this.$subscriptions.add(prevSubscription);
    }

    ngOnDestroy(): void {
        this.visibleIframe = null;
        this.iframeService.setValidationFrameVisibility(false);
        // this.iframeService.setValidationFrameSource('/');
        super.ngOnDestroy();
    }
}
